'use client';
import ScrollHelperStandart from '@lib/tools/helpers/ScrollHelperStandart';

function TemplateDocuments({ children }) {
  return (
    <>
      {children}
      <ScrollHelperStandart />
    </>
  );
}

export default TemplateDocuments;
